export default __webpack_public_path__ + "static/media/smartphoneswhite.eefe766c.png";